var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _rect, _path68, _path69, _path70, _rect2, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root>svg{display:none}:root>svg:target{display:block}")), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 18",
    id: "chat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.583a6.982 6.982 0 01-.75 3.167 7.084 7.084 0 01-6.333 3.917 6.983 6.983 0 01-3.167-.75L1.5 16.5l1.583-4.75a6.983 6.983 0 01-.75-3.167A7.083 7.083 0 016.25 2.25a6.983 6.983 0 013.167-.75h.416A7.066 7.066 0 0116.5 8.167v.416z",
    fill: "#F1F6FA",
    stroke: "#053FFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.396 7.594l-4.792 4.792M12.396 12.389L7.6 7.592",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.334.75H5.665C2.644.75.75 2.889.75 5.916v8.168c0 3.027 1.885 5.166 4.915 5.166h8.668c3.031 0 4.917-2.139 4.917-5.166V5.916c0-3.027-1.886-5.166-4.916-5.166z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 10 11",
    id: "close2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.915 3.171l-.587-.587-2.33 2.33-2.328-2.33-.588.587 2.33 2.33-2.33 2.329.588.587 2.329-2.329 2.329 2.33.587-.588L5.586 5.5l2.33-2.329z",
    fill: "#3C64B1"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 8 8",
    id: "company-close",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.397 1.595L1.605 6.387M6.398 6.39L1.602 1.593",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 44 21",
    id: "detail",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.8h41.609L31.716.935 32.598 0 44 10.461 32.598 21l-.883-.934 9.895-8.944H0V9.8z",
    fill: "#2B5CFB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    id: "dislike",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.922 0h-2.524a.221.221 0 00-.162.063.213.213 0 00-.064.16v.508C7.588.728 4.074.726 2.298.73c-.68.001-1.243.518-1.243 1.15v.021c.003.281.113.55.308.754-.472.163-.806.586-.806 1.083.005.306.136.598.364.807-.4.19-.668.58-.668 1.027v.021c-.001.318.136.621.376.833C.256 6.624 0 6.999 0 7.427c0 .634.552 1.15 1.232 1.151l3.924.004-.076 2.678v.01a1.874 1.874 0 001.65 1.818l.528.08a.24.24 0 00.184-.047c.052-.041.084-.101.09-.166l.219-2.834a1.921 1.921 0 01.832-1.44l.259-.166c.419-.272.944-.611 1.33-1v.809c0 .13.095.245.226.245h2.525a.255.255 0 00.248-.245v-8.1c0-.13-.117-.224-.248-.224zM8.58 8.125c-.092.06-.182.116-.261.17a2.385 2.385 0 00-1.04 1.79l-.201 2.582-.278-.042-.007-.001a1.412 1.412 0 01-1.238-1.357l.082-2.912a.232.232 0 00-.067-.17.24.24 0 00-.17-.07L1.23 8.11c-.418 0-.76-.3-.76-.677 0-.377.342-.677.76-.677h1.89a.236.236 0 00.237-.234.236.236 0 00-.238-.234H1.442c-.404-.03-.714-.328-.714-.695v-.021c0-.377.327-.688.746-.688h1.49a.236.236 0 00.238-.234.236.236 0 00-.237-.234h-1.17c-.419 0-.76-.31-.76-.688 0-.377.341-.686.76-.686H2.9a.236.236 0 00.237-.234.236.236 0 00-.237-.234H2.3c-.419 0-.771-.296-.771-.673v-.02c0-.376.35-.682.769-.683 1.775-.004 5.29-.002 7.873 0v5.533c-.238.515-1.02 1.022-1.592 1.394zm4.116-.024h-2.05V.468h2.05v7.633z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    id: "dislike-active",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.922 0h-2.524a.221.221 0 00-.162.063.213.213 0 00-.064.16v.508C7.588.728 4.074.726 2.298.73c-.68.001-1.243.518-1.243 1.15v.021c.003.281.113.55.308.754-.472.163-.806.586-.806 1.083.005.306.136.598.364.807-.4.19-.668.58-.668 1.027v.021c-.001.318.136.621.376.833C.256 6.624 0 6.999 0 7.427c0 .634.552 1.15 1.232 1.151l3.924.004-.076 2.678v.01a1.874 1.874 0 001.65 1.818l.528.08a.24.24 0 00.184-.047c.052-.041.084-.101.09-.166l.219-2.834a1.921 1.921 0 01.832-1.44l.259-.166c.419-.272.944-.611 1.33-1v.809c0 .13.095.245.226.245h2.525a.255.255 0 00.248-.245v-8.1c0-.13-.117-.224-.248-.224z",
    fill: "#2B5CFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.922 0h-2.524a.221.221 0 00-.162.063.213.213 0 00-.064.16v.508C7.588.728 4.074.726 2.298.73c-.68.001-1.243.518-1.243 1.15v.021c.003.281.113.55.308.754-.472.163-.806.586-.806 1.083.005.306.136.598.364.807-.4.19-.668.58-.668 1.027v.021c-.001.318.136.621.376.833C.256 6.624 0 6.999 0 7.427c0 .634.552 1.15 1.232 1.151l3.924.004-.076 2.678v.01a1.874 1.874 0 001.65 1.818l.528.08a.24.24 0 00.184-.047c.052-.041.084-.101.09-.166l.219-2.834a1.921 1.921 0 01.832-1.44l.259-.166c.419-.272.944-.611 1.33-1v.809c0 .13.095.245.226.245h2.525a.255.255 0 00.248-.245v-8.1c0-.13-.117-.224-.248-.224zM8.58 8.125c-.092.06-.182.116-.261.17a2.385 2.385 0 00-1.04 1.79l-.201 2.582-.278-.042-.007-.001a1.412 1.412 0 01-1.238-1.357l.082-2.912a.232.232 0 00-.067-.17.24.24 0 00-.17-.07L1.23 8.11c-.418 0-.76-.3-.76-.677 0-.377.342-.677.76-.677h1.89a.236.236 0 00.237-.234.236.236 0 00-.238-.234H1.442c-.404-.03-.714-.328-.714-.695v-.021c0-.377.327-.688.746-.688h1.49a.236.236 0 00.238-.234.236.236 0 00-.237-.234h-1.17c-.419 0-.76-.31-.76-.688 0-.377.341-.686.76-.686H2.9a.236.236 0 00.237-.234.236.236 0 00-.237-.234H2.3c-.419 0-.771-.296-.771-.673v-.02c0-.376.35-.682.769-.683 1.775-.004 5.29-.002 7.873 0v5.533c-.238.515-1.02 1.022-1.592 1.394zm4.116-.024h-2.05V.468h2.05v7.633z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 14",
    id: "doublecheck",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M.41 8.41L6 14l1.41-1.42L1.83 7 .41 8.41zM22.24.58L11.66 11.17 7.5 7 6.07 8.41 11.66 14l12-12L22.24.58zM18 2L16.59.58l-6.35 6.35 1.42 1.41L18 2z",
    fill: "#3C64B1",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.012l3 3-2.287 2.287-3-3L16 2.011zM4 14v3h3l8.299-8.287-3-3L4 14zm0 6h16v2H4v-2z",
    fill: "#092C9E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "facebook-f",
    className: "ajsvg-inline--fa ajfa-facebook-f ajfa-w-10",
    viewBox: "0 0 320 512",
    id: "fb",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "instagram",
    className: "aksvg-inline--fa akfa-instagram akfa-w-14",
    viewBox: "0 0 448 512",
    id: "inst",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    id: "like",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 1.294C11.56.459 10.66 0 9.673 0c-1.388 0-2.267.938-2.76 1.725a5.89 5.89 0 00-.327.602 5.889 5.889 0 00-.328-.602C5.765.938 4.886 0 3.498 0 2.513 0 1.612.46.962 1.294.341 2.09 0 3.156 0 4.295 0 5.536.428 6.69 1.347 7.927c.82 1.105 2.002 2.244 3.37 3.564.51.491 1.036 1 1.598 1.555l.016.017a.36.36 0 00.255.108.36.36 0 00.254-.108l.017-.017c.56-.555 1.088-1.064 1.598-1.555 1.367-1.32 2.549-2.46 3.37-3.564.918-1.237 1.346-2.391 1.346-3.632 0-1.14-.341-2.205-.96-3.001zm-4.256 9.532c-.44.423-.892.86-1.368 1.329-.477-.47-.93-.905-1.369-1.33C2.54 8.245.772 6.539.772 4.296c0-.926.273-1.787.768-2.424.501-.643 1.197-.997 1.959-.997 1.058 0 1.742.737 2.129 1.356.348.555.529 1.115.59 1.33.052.18.2.301.368.301.167 0 .315-.121.366-.301.062-.215.244-.775.591-1.33.388-.619 1.072-1.356 2.13-1.356.762 0 1.457.354 1.958.997.496.637.768 1.498.768 2.424 0 2.243-1.768 3.949-4.445 6.53z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    id: "like(old)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 1.294C11.56.459 10.66 0 9.673 0c-1.388 0-2.267.938-2.76 1.725a5.89 5.89 0 00-.327.602 5.889 5.889 0 00-.328-.602C5.765.938 4.886 0 3.498 0 2.513 0 1.612.46.962 1.294.341 2.09 0 3.156 0 4.295 0 5.536.428 6.69 1.347 7.927c.82 1.105 2.002 2.244 3.37 3.564.51.491 1.036 1 1.598 1.555l.016.017a.36.36 0 00.255.108.36.36 0 00.254-.108l.017-.017c.56-.555 1.088-1.064 1.598-1.555 1.367-1.32 2.549-2.46 3.37-3.564.918-1.237 1.346-2.391 1.346-3.632 0-1.14-.341-2.205-.96-3.001zm-4.256 9.532c-.44.423-.892.86-1.368 1.329-.477-.47-.93-.905-1.369-1.33C2.54 8.245.772 6.539.772 4.296c0-.926.273-1.787.768-2.424.501-.643 1.197-.997 1.959-.997 1.058 0 1.742.737 2.129 1.356.348.555.529 1.115.59 1.33.052.18.2.301.368.301.167 0 .315-.121.366-.301.062-.215.244-.775.591-1.33.388-.619 1.072-1.356 2.13-1.356.762 0 1.457.354 1.958.997.496.637.768 1.498.768 2.424 0 2.243-1.768 3.949-4.445 6.53z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    id: "like-active",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 1.294C11.56.459 10.66 0 9.673 0c-1.388 0-2.267.938-2.76 1.725a5.89 5.89 0 00-.327.602 5.889 5.889 0 00-.328-.602C5.765.938 4.886 0 3.498 0 2.513 0 1.612.46.962 1.294.341 2.09 0 3.156 0 4.295 0 5.536.428 6.69 1.347 7.927c.82 1.105 2.002 2.244 3.37 3.564.51.491 1.036 1 1.598 1.555l.016.017a.36.36 0 00.255.108.36.36 0 00.254-.108l.017-.017c.56-.555 1.088-1.064 1.598-1.555 1.367-1.32 2.549-2.46 3.37-3.564.918-1.237 1.346-2.391 1.346-3.632 0-1.14-.341-2.205-.96-3.001z",
    fill: "#2B5CFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 1.294C11.56.459 10.66 0 9.673 0c-1.388 0-2.267.938-2.76 1.725a5.89 5.89 0 00-.327.602 5.889 5.889 0 00-.328-.602C5.765.938 4.886 0 3.498 0 2.513 0 1.612.46.962 1.294.341 2.09 0 3.156 0 4.295 0 5.536.428 6.69 1.347 7.927c.82 1.105 2.002 2.244 3.37 3.564.51.491 1.036 1 1.598 1.555l.016.017a.36.36 0 00.255.108.36.36 0 00.254-.108l.017-.017c.56-.555 1.088-1.064 1.598-1.555 1.367-1.32 2.549-2.46 3.37-3.564.918-1.237 1.346-2.391 1.346-3.632 0-1.14-.341-2.205-.96-3.001zm-4.256 9.532c-.44.423-.892.86-1.368 1.329-.477-.47-.93-.905-1.369-1.33C2.54 8.245.772 6.539.772 4.296c0-.926.273-1.787.768-2.424.501-.643 1.197-.997 1.959-.997 1.058 0 1.742.737 2.129 1.356.348.555.529 1.115.59 1.33.052.18.2.301.368.301.167 0 .315-.121.366-.301.062-.215.244-.775.591-1.33.388-.619 1.072-1.356 2.13-1.356.762 0 1.457.354 1.958.997.496.637.768 1.498.768 2.424 0 2.243-1.768 3.949-4.445 6.53z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "linkedin-in",
    className: "aosvg-inline--fa aofa-linkedin-in aofa-w-14",
    viewBox: "0 0 448 512",
    id: "linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 01107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 20",
    id: "location",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM7 0a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7z",
    fill: "#3C64B1",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 20",
    id: "location-current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM7 0a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    id: "mess",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.583a6.983 6.983 0 01-.75 3.167 7.084 7.084 0 01-6.333 3.917 6.983 6.983 0 01-3.167-.75L2.5 17.5l1.583-4.75a6.983 6.983 0 01-.75-3.167A7.083 7.083 0 017.25 3.25a6.983 6.983 0 013.167-.75h.416A7.066 7.066 0 0117.5 9.167v.416z",
    fill: "#F1F6FA",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 18",
    id: "mess-active",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.583a6.982 6.982 0 01-.75 3.167 7.084 7.084 0 01-6.333 3.917 6.983 6.983 0 01-3.167-.75L1.5 16.5l1.583-4.75a6.983 6.983 0 01-.75-3.167A7.083 7.083 0 016.25 2.25a6.983 6.983 0 013.167-.75h.416A7.066 7.066 0 0116.5 8.167v.416z",
    fill: "#092C9E",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 15 10",
    id: "new-arr",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.908 4.78L10.221.091a.312.312 0 10-.442.441l4.154 4.155H.313a.312.312 0 100 .625h13.62L9.78 9.467a.312.312 0 10.442.441l4.688-4.687a.312.312 0 000-.442z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    id: "notific",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.666a5 5 0 00-10 0c0 5.833-2.5 7.5-2.5 7.5h15s-2.5-1.667-2.5-7.5zM11.442 17.5a1.666 1.666 0 01-2.883 0",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#092C9E",
    viewBox: "0 0 20 20",
    id: "notific-active",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.666a5 5 0 00-10 0c0 5.833-2.5 7.5-2.5 7.5h15s-2.5-1.667-2.5-7.5zM11.442 17.5a1.666 1.666 0 01-2.883 0",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 18",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11h-.79l-.28-.27A6.471 6.471 0 0013 6.5 6.5 6.5 0 106.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.165 12.5a1.374 1.374 0 00.275 1.517l.05.05a1.667 1.667 0 11-2.358 2.359l-.05-.05a1.376 1.376 0 00-1.517-.275 1.376 1.376 0 00-.833 1.258v.142a1.667 1.667 0 01-3.333 0v-.075a1.375 1.375 0 00-.9-1.259 1.375 1.375 0 00-1.517.275l-.05.05a1.667 1.667 0 11-2.358-2.358l.05-.05a1.375 1.375 0 00.275-1.517 1.374 1.374 0 00-1.259-.833H2.5a1.667 1.667 0 110-3.333h.075a1.375 1.375 0 001.258-.9 1.375 1.375 0 00-.275-1.517l-.05-.05a1.667 1.667 0 112.358-2.358l.05.05a1.375 1.375 0 001.517.275h.067a1.375 1.375 0 00.833-1.259v-.141a1.667 1.667 0 013.333 0v.075a1.374 1.374 0 00.834 1.258 1.375 1.375 0 001.516-.275l.05-.05a1.667 1.667 0 112.359 2.358l-.05.05a1.375 1.375 0 00-.275 1.517v.067a1.375 1.375 0 001.258.833h.142a1.667 1.667 0 010 3.333h-.075a1.375 1.375 0 00-1.259.834v0z",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "#F4F7FF",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 19",
    id: "star-active",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19 10 15.27z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 19",
    id: "star-half",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.24l-7.19-.62L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19 10 15.27 16.18 19l-1.63-7.03L20 7.24zM10 13.4V4.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L10 13.4z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 19",
    id: "star-notactive",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.24l-7.19-.62L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19 10 15.27 16.18 19l-1.63-7.03L20 7.24zM10 13.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L10 4.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L10 13.4z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 19",
    id: "star-white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19 10 15.27z",
    fill: "#F1F6FA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 404 316",
    id: "thumbnail",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#18A0FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.833 39.5H84.167C65.573 39.5 50.5 51.29 50.5 65.833v184.334c0 14.543 15.073 26.333 33.667 26.333h235.666c18.594 0 33.667-11.79 33.667-26.333V65.833c0-14.543-15.073-26.333-33.667-26.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.084 131.666c13.945 0 25.25-8.842 25.25-19.75s-11.305-19.75-25.25-19.75-25.25 8.842-25.25 19.75 11.305 19.75 25.25 19.75zM353.499 197.499l-84.166-65.833L84.166 276.499"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 10",
    id: "v",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5l-7 7-7-7",
    stroke: "#092C9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    id: "new-check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1L6 12L1 7",
    stroke: "#0F47C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "portDelete",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3238 7.46777C16.3238 7.46777 15.7808 14.2028 15.4658 17.0398C15.3158 18.3948 14.4788 19.1888 13.1078 19.2138C10.4988 19.2608 7.88681 19.2638 5.27881 19.2088C3.95981 19.1818 3.13681 18.3778 2.98981 17.0468C2.67281 14.1848 2.13281 7.46777 2.13281 7.46777",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.708 4.23926H0.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4406 4.23949C13.6556 4.23949 12.9796 3.68449 12.8256 2.91549L12.5826 1.69949C12.4326 1.13849 11.9246 0.750488 11.3456 0.750488H7.11258C6.53358 0.750488 6.02558 1.13849 5.87558 1.69949L5.63258 2.91549C5.47858 3.68449 4.80258 4.23949 4.01758 4.23949",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "portEdit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.01221L19.0002 5.01251L16.7134 7.29926L13.7132 4.29895L16 2.01221Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.9999V16.9999H7L15.299 8.71289L12.299 5.71289L4 13.9999ZM4 19.9999H20V21.9999H4V19.9999Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "buttonClear",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3936 7.59497L7.60156 12.387",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3976 12.3898L7.60156 7.59277",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.334 0.750244H5.665C2.644 0.750244 0.75 2.88924 0.75 5.91624V14.0842C0.75 17.1112 2.635 19.2502 5.665 19.2502H14.333C17.364 19.2502 19.25 17.1112 19.25 14.0842V5.91624C19.25 2.88924 17.364 0.750244 14.334 0.750244Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "modalClose",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3955 7.59473L7.60352 12.3867",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3976 12.3898L7.60156 7.59277",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.335 0.75H5.66598C2.64498 0.75 0.750977 2.889 0.750977 5.916V14.084C0.750977 17.111 2.63598 19.25 5.66598 19.25H14.334C17.365 19.25 19.251 17.111 19.251 14.084V5.916C19.251 2.889 17.365 0.75 14.335 0.75Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "modalCloseWhite",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3955 7.59473L7.60352 12.3867",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3976 12.3898L7.60156 7.59277",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.335 0.75H5.66598C2.64498 0.75 0.750977 2.889 0.750977 5.916V14.084C0.750977 17.111 2.63598 19.25 5.66598 19.25H14.334C17.365 19.25 19.251 17.111 19.251 14.084V5.916C19.251 2.889 17.365 0.75 14.335 0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "paymentLabel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13V17H11V11ZM11 7H13V9H11V7Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "pinExpert",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5199 12.0589C29.3292 13.102 27.5559 13.4151 25.8867 12.7892L21.9227 16.7532C22.0272 19.1525 22.0272 23.638 21.2968 25.0989C19.732 28.4369 15.2463 26.5593 11.2825 22.9082L0.746387 31.8792C0.641951 31.9836 0.329128 32.0878 0.120491 31.8792C-0.0881462 31.6706 0.0160561 31.3575 0.120491 31.2533L9.0915 20.7172C5.44038 16.7533 3.56268 12.2679 6.90079 10.7028C8.3612 9.97255 12.8468 9.97255 15.2465 10.077L19.2105 6.11301C18.5846 4.44399 18.8974 2.6705 19.9408 0.479796C21.5056 -2.64964 34.6497 10.4942 31.5202 12.0592L31.5199 12.0589Z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "proExpert",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3553 20.2666L31.7304 14.7344L28.2036 20.3954L21.8242 22.1358L26.1228 27.2361L25.7971 33.8504L31.9801 31.3377L38.1632 33.684L37.686 27.0317L41.833 21.8707L35.3553 20.2666Z",
    fill: "#0F47C0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8215 8.44531C27.3335 8.44531 23.0297 10.2279 19.8561 13.4016C16.6831 16.5746 14.9004 20.879 14.9004 25.3664C14.9004 29.8545 16.683 34.1583 19.8561 37.3318C23.0297 40.5049 27.3335 42.2881 31.8215 42.2881C36.3095 42.2881 40.6134 40.505 43.7864 37.3318C46.9599 34.1583 48.7427 29.8545 48.7427 25.3664C48.739 20.88 46.9548 16.5784 43.7822 13.4058C40.6096 10.2332 36.3079 8.4495 31.8215 8.44531ZM40.683 37.074L32.0031 33.7748L23.3533 37.2862L23.8073 28.0155L17.791 20.8718L26.7513 18.4499L31.6854 10.519L36.771 18.2756L45.852 20.546L40.0173 27.7578L40.683 37.074Z",
    fill: "#0F47C0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8866 48.2951L14.4011 47.1676L11.8662 41.2575L10.1485 40.0312L0 50.1797L10.0877 54.0618L13.9697 64.1422L25.6618 52.4502L20.8866 48.2951Z",
    fill: "#0F47C0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.594 39.7148L52.0801 40.8197L49.5379 46.8967L43.2113 48.0548L38.3301 52.3755L50.0374 64.0907L53.9194 54.003L63.9998 50.1284L53.594 39.7148Z",
    fill: "#0F47C0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8972 44.8838L50.213 39.3515L54.9276 35.9156L54.6171 29.9294L57.3716 24.7911L54.4958 19.5313L54.7529 13.7041L49.8796 10.2154L47.5944 4.82792L41.6916 3.79855L37.3024 0L31.5284 1.63488L25.8981 0.121488L21.4106 4.07153L15.6668 5.1236L13.3509 10.6478L8.63642 14.0838L8.94682 20.07L6.19922 25.2079L9.07506 30.4677L8.81799 36.3023L13.6913 39.791L15.9617 45.1563L21.8645 46.1857L26.2612 50.0224L32.0277 48.3875L37.658 49.9009L42.1455 45.9281L47.8972 44.8838ZM31.8227 44.5581C26.7329 44.5581 21.8511 42.5363 18.2523 38.9372C14.6532 35.3381 12.6314 30.4568 12.6314 25.3668C12.6314 20.277 14.6532 15.3957 18.2523 11.7963C21.8514 8.19725 26.7332 6.17493 31.8227 6.17493C36.9122 6.17493 41.7938 8.19725 45.3931 11.7963C48.9922 15.3954 51.014 20.2767 51.014 25.3668C51.0082 30.4549 48.9842 35.3331 45.3862 38.9304C41.7882 42.5284 36.9107 44.5522 31.8227 44.5581Z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "modalCheckbox",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1L6 12L1 7",
    stroke: "#18171C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "hotProject",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.168 0 0 7.168 0 16C0 24.832 7.168 32 16 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 16 0ZM22.688 16.096C22.8159 17.5359 23.0081 19.2319 22.24 21.152C21.632 22.656 19.9041 24.7359 17.472 25.2799C18.88 24.6718 19.8079 23.2319 19.68 21.6C19.6159 20.704 19.072 19.8399 18.4961 19.2319C18.1441 21.5359 16.8961 21.792 16.8961 21.792C16.8961 21.792 17.6001 20.288 17.728 18.6239C17.7599 17.984 17.728 17.2799 17.536 16.5441C16.8639 14.176 15.7441 13.536 15.7441 13.536C15.7441 13.536 16.128 14.9119 14.7522 17.1521C13.7921 18.688 12.1921 19.84 12.2562 22.144C12.2881 23.392 12.9921 24.448 14.0162 25.0239C11.8722 24.2879 10.0803 22.4638 9.12022 19.7118C7.74433 15.7759 10.5923 12.6398 10.5923 12.6398C10.5921 12.6401 10.5602 13.4722 10.8801 14.3682C11.2321 15.2322 11.9042 15.9041 11.9042 15.9041C11.9042 15.9041 11.2321 14.0481 12.8642 10.9441C14.6881 7.45611 18.6882 6.72017 18.6882 6.72017C18.6882 6.72017 17.6963 8.38423 18.1443 10.1121C18.4963 11.392 19.0721 12.0001 19.7123 13.7282C20.3523 15.4882 20.2563 16.4802 20.2563 16.4802C20.2563 16.4802 20.4483 15.3601 20.8962 14.6242C21.8882 12.9922 23.2322 12.6081 23.2322 12.6081C23.2322 12.6081 22.5282 14.1121 22.6882 16.0961L22.688 16.096Z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "premium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2907 10.2233L13.9242 10.4592L12.7453 11.6042C12.55 11.7984 12.4566 12.0724 12.4927 12.3452L12.7791 13.9788L11.3139 13.204V13.2043C11.0678 13.0921 10.7852 13.0921 10.5391 13.2043L9.07389 13.9791L9.36023 12.3455V12.3452C9.39636 12.0724 9.30297 11.7984 9.10766 11.6042L7.92876 10.4592L9.5623 10.2233C9.83661 10.1722 10.0721 9.99837 10.2023 9.75168L10.9265 8.28648L11.6507 9.75168C11.7808 9.99837 12.0164 10.1722 12.2907 10.2233H12.2907ZM21.8737 10.9476C21.8713 13.9191 20.6546 16.7606 18.5053 18.8127C17.994 19.321 17.4293 19.773 16.8211 20.1601C15.0636 21.2925 13.0175 21.8946 10.9267 21.8946C8.83599 21.8946 6.78984 21.2926 5.03239 20.1601C4.42416 19.773 3.85936 19.3211 3.3481 18.8127C0.704307 16.2652 -0.484816 12.5609 0.182148 8.94992C0.84912 5.33955 3.28322 2.30457 6.663 0.869816C10.0425 -0.56516 13.9168 -0.208334 16.9776 1.81962C20.0384 3.84758 21.8775 7.27578 21.874 10.9478L21.8737 10.9476ZM16.535 9.61719C16.4363 9.3047 16.1682 9.07621 15.8442 9.02775L12.9643 8.62363L11.6844 6.01329V6.013C11.5299 5.73987 11.2406 5.571 10.9267 5.571C10.6127 5.571 10.3235 5.73987 10.169 6.013L8.8891 8.62334L6.00915 9.02746V9.02775C5.68521 9.07621 5.41707 9.3047 5.31839 9.61719C5.21883 9.92174 5.3043 10.2563 5.53749 10.4759L7.6259 12.4968L7.12074 15.3768H7.12045C7.06201 15.6957 7.19152 16.02 7.45408 16.2106C7.71635 16.4012 8.06496 16.4241 8.34983 16.2696L10.9266 14.9054L13.5034 16.2696C13.6256 16.3231 13.7572 16.3519 13.8908 16.3536C14.0706 16.3554 14.2468 16.3025 14.396 16.2021C14.653 16.0112 14.7828 15.6931 14.7328 15.3768L14.2277 12.4968L16.3161 10.4759H16.3158C16.549 10.2562 16.6345 9.92173 16.5349 9.61717L16.535 9.61719ZM10.9266 23.579C8.51284 23.5819 6.14979 22.8856 4.12273 21.5749C3.85313 21.4066 3.60055 21.2213 3.34795 21.0359V31.1573C3.35265 31.451 3.50449 31.7233 3.75207 31.8813C3.99907 32.0266 4.30244 32.0393 4.56061 31.915L10.9266 28.732L17.2927 31.915C17.409 31.9688 17.5353 31.9973 17.6633 31.9993C17.8175 32.0023 17.9694 31.9614 18.1012 31.8813C18.3488 31.7233 18.5006 31.451 18.5053 31.1573V21.0359C18.2528 21.2213 18.0002 21.4066 17.7306 21.5749C15.7035 22.8856 13.3404 23.5819 10.9266 23.579L10.9266 23.579Z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "whatsapp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M14.013 0.666016C6.67169 0.666016 0.695375 6.63718 0.692708 13.9785C0.691375 16.3252 1.30602 18.6161 2.47135 20.6348L0.664062 27.3327L7.64062 25.6842C9.58596 26.7456 11.7759 27.3027 14.0052 27.304H14.0104C21.3504 27.304 27.3241 21.3315 27.3281 13.9915C27.3308 10.4329 25.947 7.08699 23.4323 4.56966C20.9176 2.05366 17.5757 0.667349 14.013 0.666016ZM14.0104 3.33268C16.8584 3.33402 19.5349 4.44441 21.5469 6.45508C23.5589 8.46841 24.6641 11.1436 24.6615 13.9889C24.6588 19.8609 19.8825 24.6374 14.0078 24.6374C12.2305 24.636 10.4699 24.1898 8.91927 23.3431L8.02083 22.8535L7.02865 23.0879L4.40365 23.7077L5.04427 21.3275L5.33333 20.2598L4.78125 19.3014C3.85058 17.6908 3.35804 15.8492 3.35938 13.9785C3.36204 8.10918 8.13975 3.33268 14.0104 3.33268ZM9.29948 7.83268C9.07681 7.83268 8.71679 7.91602 8.41146 8.24935C8.10613 8.58135 7.24479 9.38545 7.24479 11.0228C7.24479 12.6601 8.4375 14.2428 8.60417 14.4655C8.7695 14.6868 10.9064 18.153 14.2891 19.4863C17.0997 20.5943 17.6706 20.3757 18.2812 20.3197C18.8919 20.265 20.2513 19.5163 20.5286 18.7389C20.806 17.9616 20.8066 17.2929 20.724 17.1556C20.6413 17.0169 20.4193 16.9342 20.0859 16.7676C19.7539 16.6009 18.1178 15.7975 17.8125 15.6868C17.5072 15.5762 17.2838 15.5202 17.0625 15.8535C16.8412 16.1868 16.2051 16.9343 16.0104 17.1556C15.8158 17.3783 15.6224 17.4082 15.2891 17.2415C14.9557 17.0735 13.884 16.7212 12.612 15.5879C11.6226 14.7066 10.9551 13.6191 10.7604 13.2858C10.5671 12.9538 10.7422 12.7715 10.9089 12.6061C11.0582 12.4568 11.2396 12.2175 11.4062 12.0228C11.5716 11.8281 11.6289 11.6894 11.7396 11.4681C11.8503 11.2468 11.7936 11.0514 11.7109 10.8848C11.6283 10.7181 10.9809 9.07468 10.6849 8.41602C10.4356 7.86268 10.1722 7.84983 9.9349 7.84049C9.74156 7.83249 9.52081 7.83268 9.29948 7.83268Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "telegram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8344 0.250065C23.4876 0.265362 23.1646 0.366356 22.8802 0.481315C22.6138 0.588476 21.5959 1.02504 19.9927 1.71256C18.3881 2.40069 16.2634 3.3129 13.9969 4.28756C9.46389 6.2369 4.36762 8.43118 1.75729 9.55423C1.65914 9.59645 1.31664 9.70586 0.953125 9.98965C0.589609 10.2734 0.203125 10.8615 0.203125 11.5167C0.203125 12.0451 0.45493 12.57 0.771875 12.8834C1.08882 13.1968 1.42419 13.3516 1.71146 13.4688C2.75377 13.8941 5.98643 15.217 6.59687 15.4667C6.81171 16.1248 7.98178 19.7041 8.25312 20.5813C8.432 21.1602 8.60227 21.5228 8.82396 21.8105C8.9348 21.9543 9.06365 22.0804 9.21979 22.1792C9.2822 22.2187 9.35063 22.2491 9.41979 22.2771L9.42396 22.2792C9.43989 22.2856 9.45363 22.2965 9.46979 22.3021C9.50028 22.3128 9.52067 22.3141 9.56146 22.323C9.72394 22.3755 9.88798 22.4084 10.0344 22.4084C10.6585 22.4084 11.0406 22.0646 11.0406 22.0646L11.0635 22.048L14.274 19.2709L18.1677 22.9542C18.2225 23.0318 18.7338 23.7334 19.8615 23.7334C20.531 23.7334 21.0621 23.3974 21.4031 23.0396C21.7441 22.6819 21.9566 22.306 22.0469 21.8334V21.8313C22.1313 21.3847 25.7198 2.96256 25.7198 2.96256L25.7135 2.98756C25.8186 2.50808 25.8461 2.06155 25.7302 1.6209C25.6143 1.18025 25.3089 0.758348 24.9302 0.531315C24.5516 0.304332 24.1811 0.234768 23.8344 0.250065ZM23.6344 2.47923C23.6293 2.51036 23.6382 2.49471 23.6302 2.53131L23.6281 2.54381L23.626 2.55631C23.626 2.55631 20.082 20.7429 19.951 21.4355C19.9606 21.3832 19.9168 21.4872 19.8719 21.5501C19.8084 21.5063 19.6781 21.4501 19.6781 21.4501L19.6573 21.4271L14.3385 16.3959L10.5781 19.6459L11.6969 15.1667C11.6969 15.1667 18.6901 7.92765 19.1115 7.50631C19.4507 7.16925 19.5219 7.05175 19.5219 6.93548C19.5219 6.77975 19.4407 6.66673 19.2594 6.66673C19.0962 6.66673 18.8767 6.8254 18.7594 6.90006C17.2307 7.87451 10.5197 11.7858 7.51146 13.5355C7.03339 13.3398 3.7121 11.9803 2.58646 11.5209C2.59498 11.5172 2.59218 11.5185 2.60104 11.5146C5.21205 10.3913 10.3062 8.19704 14.8385 6.24798C17.1047 5.27345 19.231 4.36055 20.8344 3.67298C22.413 2.996 23.5099 2.53008 23.6344 2.47923Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "viber",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6992 0C10.7992 0 6.09954 0.199609 3.59954 2.59961C1.79954 4.29961 1.09993 6.9 0.999934 10C0.799934 14.9 1.89915 17.9996 3.69915 19.5996C4.09915 19.8996 5.09993 20.7008 6.99993 21.3008V23.8008C6.99993 23.8008 6.99954 24.8 7.59954 25C7.69954 25 7.80032 25.0996 7.90032 25.0996C8.50032 25.0996 8.99915 24.3992 9.69915 23.6992C10.2992 22.9992 10.7995 22.5 11.0995 22H12.4999H13.3007C15.2007 22 19.9003 21.8004 22.4003 19.4004C24.2003 17.6004 24.9003 14.9992 24.9003 11.6992C25.0003 11.1992 24.9999 10.6 24.9999 10C24.8999 6.3 23.8007 3.80039 22.3007 2.40039C21.7007 1.90039 19.0999 0 13.4999 0H12.6992ZM12.4999 1.90039H13.1992H13.3007H13.4003C18.7003 1.90039 20.7003 3.60078 20.9003 3.80078C22.1003 4.80078 22.8003 7.00039 22.9003 9.90039V10.3008C23.0003 10.9008 22.9999 11.3992 22.9999 11.6992C22.8999 14.6992 22.2995 16.7 21.0995 18C18.9995 19.9 14.6003 20 13.4003 20H12.6992H12.5995H12.4999H11.4999L9.90032 21.8008L8.90032 22.9004L8.69915 23.1992C8.49915 23.3992 8.19993 23.8004 7.99993 23.9004V23.6992V19.4004C5.99993 18.9004 5.19993 18.2 4.99993 18C3.59993 16.8 2.79993 13.9 2.99993 10V9C3.19993 6.6 3.80071 5.00039 4.80071 3.90039C6.90071 2.00039 11.2999 1.90039 12.4999 1.90039ZM12.4003 4.09961C11.9003 4.09961 11.9003 4.80078 12.4003 4.80078C16.1003 4.80078 19.3007 7.3 19.3007 12C19.3007 12.5 19.9999 12.5 19.9999 12C19.9999 6.9 16.6003 3.99961 12.4003 4.09961ZM8.43743 5.02539C8.22493 5.00039 8.00071 5.04922 7.80071 5.19922C6.80071 5.69922 5.79954 6.70078 6.09954 7.80078C6.09954 7.80078 6.30032 8.69961 7.40032 10.5996C8.00032 11.4996 8.49993 12.3004 8.99993 12.9004C9.49993 13.6004 10.2995 14.4 11.0995 15C12.6995 16.3 15.2007 17.6004 16.3007 17.9004C17.3007 18.2004 18.4003 17.1992 18.9003 16.1992C19.1003 15.7992 18.9995 15.3 18.5995 15C17.9995 14.4 17.0007 13.7008 16.3007 13.3008C15.8007 13.0008 15.1999 13.2 14.9999 13.5L14.4999 14.0996C14.2999 14.3996 13.8007 14.4004 13.8007 14.4004C10.5007 13.5004 9.59954 10.0996 9.59954 10.0996C9.59954 10.0996 9.60032 9.70039 9.90032 9.40039L10.4999 8.90039C10.7999 8.70039 10.9992 8.09961 10.6992 7.59961C10.4992 7.29961 10.2003 6.70039 9.90032 6.40039C9.60032 6.00039 8.99993 5.30078 8.99993 5.30078C8.84993 5.15078 8.64993 5.05039 8.43743 5.02539ZM13.0995 6.09961C12.5995 5.99961 12.4999 6.80078 12.9999 6.80078C15.7999 7.00078 17.4007 8.90078 17.3007 11.3008C17.2007 11.8008 17.9999 11.8008 17.9999 11.3008C18.0999 8.50078 16.2995 6.19961 13.0995 6.09961ZM13.4003 8C12.9003 7.9 12.9003 8.69922 13.4003 8.69922C14.6003 8.69922 15.1992 9.39961 15.1992 10.5996C15.2992 11.0996 15.9999 11.0996 15.9999 10.5996C15.8999 8.99961 15.0003 8 13.4003 8Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "facebook",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 0.666016C6.64939 0.666016 0.664062 6.65134 0.664062 13.9993C0.664062 21.3474 6.64939 27.3327 13.9974 27.3327C21.3454 27.3327 27.3307 21.3474 27.3307 13.9993C27.3307 6.65134 21.3454 0.666016 13.9974 0.666016ZM13.9974 3.33268C19.9042 3.33268 24.6641 8.09252 24.6641 13.9993C24.6641 19.352 20.7512 23.75 15.6224 24.5306V17.179H18.7266L19.2135 14.0254H15.6224V12.3014C15.6224 10.9908 16.0494 9.82747 17.276 9.82747H19.2448V7.07487C18.8981 7.0282 18.1665 6.92643 16.7839 6.92643C13.8959 6.92643 12.2031 8.45176 12.2031 11.9264V14.0254H9.23437V17.179H12.2031V24.5046C7.15778 23.6538 3.33073 19.293 3.33073 13.9993C3.33073 8.09252 8.09057 3.33268 13.9974 3.33268Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    id: "timeSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM13.75 11.5H9.75C9.35 11.5 9 11.15 9 10.75V4.75C9 4.35 9.35 4 9.75 4C10.15 4 10.5 4.35 10.5 4.75V10H13.75C14.15 10 14.5 10.35 14.5 10.75C14.5 11.15 14.15 11.5 13.75 11.5Z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    id: "viewSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4 0 0 8 0 8C0 8 4 16 11 16C18 16 22 8 22 8C22 8 18 0 11 0ZM14 8C14 9.65685 12.6569 11 11 11C9.34315 11 8 9.65685 8 8C8 6.34315 9.34315 5 11 5C12.6569 5 14 6.34315 14 8Z",
    fill: "#0F47C0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "pbEdit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.01172L19.0002 5.01203L16.7134 7.29877L13.7132 4.29846L16 2.01172Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.9999V16.9999H7L15.299 8.71289L12.299 5.71289L4 13.9999ZM4 19.9999H20V21.9999H4V19.9999Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "stavka",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#0F47C0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16V12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H12.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "stavkaErr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#E54934"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16V12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H12.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    id: "star-half",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.24L12.81 6.62L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27L16.18 19L14.55 11.97L20 7.24ZM10 13.4V4.1L11.71 8.14L16.09 8.52L12.77 11.4L13.77 15.68L10 13.4Z",
    fill: "#121232"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "handleClose",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8346 1.34102L10.6596 0.166016L6.0013 4.82435L1.34297 0.166016L0.167969 1.34102L4.8263 5.99935L0.167969 10.6577L1.34297 11.8327L6.0013 7.17435L10.6596 11.8327L11.8346 10.6577L7.1763 5.99935L11.8346 1.34102Z",
    fill: "#0A243F"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "projectError",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#E54934",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H12.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    id: "mainSearch",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5898 19.9004C16.0081 19.9004 19.5898 16.3187 19.5898 11.9004C19.5898 7.48211 16.0081 3.90039 11.5898 3.90039C7.17157 3.90039 3.58984 7.48211 3.58984 11.9004C3.58984 16.3187 7.17157 19.9004 11.5898 19.9004Z",
    stroke: "#18171C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5902 21.9008L17.2402 17.5508",
    stroke: "#18171C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "mainLang",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM20.28 7.2H16.8C16.44 5.64 15.84 4.32 15.12 2.88C17.28 3.72 19.2 5.16 20.28 7.2ZM12 2.4C12.96 3.84 13.8 5.4 14.28 7.2H9.72C10.2 5.52 11.04 3.84 12 2.4ZM2.76 14.4C2.52 13.68 2.4 12.84 2.4 12C2.4 11.16 2.52 10.32 2.76 9.6H6.84C6.72 10.44 6.72 11.16 6.72 12C6.72 12.84 6.84 13.56 6.84 14.4H2.76ZM3.72 16.8H7.2C7.56 18.36 8.16 19.68 8.88 21.12C6.72 20.28 4.8 18.84 3.72 16.8ZM7.2 7.2H3.72C4.92 5.16 6.72 3.72 8.88 2.88C8.16 4.32 7.56 5.64 7.2 7.2ZM12 21.6C11.04 20.16 10.2 18.6 9.72 16.8H14.28C13.8 18.48 12.96 20.16 12 21.6ZM14.76 14.4H9.24C9.12 13.56 9 12.84 9 12C9 11.16 9.12 10.44 9.24 9.6H14.88C15 10.44 15.12 11.16 15.12 12C15.12 12.84 14.88 13.56 14.76 14.4ZM15.12 21.12C15.84 19.8 16.44 18.36 16.8 16.8H20.28C19.2 18.84 17.28 20.28 15.12 21.12ZM17.28 14.4C17.4 13.56 17.4 12.84 17.4 12C17.4 11.16 17.28 10.44 17.28 9.6H21.36C21.6 10.32 21.72 11.16 21.72 12C21.72 12.84 21.6 13.68 21.36 14.4H17.28Z",
    fill: "#F2F3F7"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "mainArr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5L12 15.5L5 8.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "mainArrBlack",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5L12 15.5L5 8.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "chatFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20863e-07 4.996L3.20863e-07 13C3.20863e-07 14.838 0.737 16.586 2.076 17.924C3.415 19.263 5.163 20 7 20C8.838 20 10.586 19.263 11.924 17.924C13.263 16.586 14 14.838 14 13L14 5H12L12 13C12 14.303 11.471 15.55 10.51 16.51C9.55 17.471 8.303 18 7 18C5.698 18 4.451 17.471 3.49 16.51C2.529 15.55 2 14.303 2 13L2 5H1L2 4.999V4.996C2 4.206 2.314 3.457 2.886 2.887C3.457 2.316 4.208 2.001 5.002 2C5.39471 2.00032 5.78345 2.07863 6.14566 2.23038C6.50787 2.38213 6.83633 2.6043 7.112 2.884C7.39216 3.16078 7.61484 3.49021 7.76723 3.85335C7.91963 4.21649 7.99873 4.60618 8 5L8 13C7.99842 13.1304 7.9711 13.2591 7.91962 13.3789C7.86814 13.4987 7.7935 13.6071 7.7 13.698C7.60904 13.7921 7.50035 13.8672 7.3802 13.919C7.26006 13.9708 7.13084 13.9984 7 14C6.748 14 6.493 13.89 6.302 13.699C6.20788 13.6083 6.13272 13.4998 6.08088 13.3798C6.02904 13.2598 6.00154 13.1307 6 13L6 5H4L4 13C4 13.79 4.315 14.541 4.889 15.114C5.461 15.686 6.211 16 7 16C7.789 16 8.54 15.686 9.114 15.112C9.39394 14.836 9.61638 14.5072 9.76846 14.1447C9.92054 13.7822 9.99924 13.3931 10 13L10 4.999C9.99953 4.34282 9.86913 3.69322 9.61631 3.0877C9.36349 2.48217 8.99327 1.9327 8.527 1.471C8.06516 1.00524 7.51563 0.635561 6.91015 0.383312C6.30467 0.131063 5.65522 0.00123787 4.99929 0.00133133C4.34337 0.00142479 3.69395 0.131433 3.08854 0.383854C2.48313 0.636274 1.93371 1.00611 1.472 1.472C1.0055 1.93265 0.63515 2.48137 0.382458 3.08632C0.129766 3.69127 -0.000235724 4.34039 3.20863e-07 4.996Z",
    fill: "#79758A"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "chatSend",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4267 8.09517L1.42674 0.095167C1.25556 0.0146173 1.06503 -0.0157201 0.877299 0.00767786C0.689563 0.0310758 0.512316 0.107249 0.36614 0.227352C0.219964 0.347455 0.110857 0.50656 0.0514882 0.686191C-0.00788074 0.865822 -0.0150756 1.05861 0.0307394 1.24217L1.24274 6.09117L9.00074 9.00017L1.24274 11.9092L0.0307394 16.7582C-0.0159376 16.9419 -0.00934325 17.135 0.0497511 17.3151C0.108845 17.4952 0.217996 17.6547 0.364436 17.7751C0.510875 17.8954 0.688549 17.9715 0.876672 17.9946C1.0648 18.0176 1.25559 17.9866 1.42674 17.9052L18.4267 9.90517C18.5985 9.82441 18.7438 9.69642 18.8455 9.53617C18.9473 9.37591 19.0013 9.19 19.0013 9.00017C19.0013 8.81034 18.9473 8.62443 18.8455 8.46417C18.7438 8.30391 18.5985 8.17592 18.4267 8.09517Z",
    fill: "#79758A"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "chatDownload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-box-arrow-in-down",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.b3147b1185a6c480a7b7a82460f587f5.svg";
export { ForwardRef as ReactComponent };